export const insuranceMetaFields = [
    {
        name: 'Insurance',
        field: 'organizationID',
        check: 'required',
    },
    {
        name: 'Dependant',
        field: 'principalOfDependantId',
        check: 'required',
    },
    {
        name: 'Member No',
        field: 'memberNo',
        check: 'required',
    },
    {
        name: 'Member ID No',
        field: 'memberIDNo',
        check: 'required',
    },
    {
        name: 'Member ID No',
        field: 'confirmMemberIDNo',
        field2: 'memberIDNo',
        check: 'confirmed',
    },
    {
        name: 'Member No',
        field: 'confirmMemberNo',
        field2: 'memberNo',
        check: 'confirmed',
    },
    
];

export const nokMetaFields = [
    {
        name: 'Name',
        field: 'name',
        check: 'required',
    },
    {
        name: 'Relationship',
        field: 'relationship',
        check: 'required',
    },
    {
        name: 'Phone No',
        field: 'telephone',
        check: 'required',
    },
    {
        name: 'Phone No',
        field: 'telephone',
        check: 'min',
        value: 9
    },
    {
        name: 'National ID',
        field: 'nationalid',
        check: 'required',
    },
    {
        name: 'ID/ Passport No',
        field: 'nationalid',
        check: 'min',
        value: 5
    },
];